<template>
  <div class="order-common">
    <b-modal
      id="md-change-status-excel"
      hide-footer
      title="Đổi trạng thái các đơn hàng:"
      no-close-on-backdrop
      size="xl"
    >
      <div class="mt-4">
        <div class="mb-4">
          <b-row>
            <b-col>
              <div class="form-group">
                <span>
                  <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file excel
                  đúng format, hoặc có thể tải ở
                  <a :href="urlExcel">đây</a>
                </span>
              </div>
            </b-col>
          </b-row>
          <!-- Nhập file -->
          <b-row>
            <b-col cols="12">
              <span> <b>Bước 2:</b> Nhập sản phẩm và tải lên </span>
              <UploadFileMulter
                v-on:send-file="getDataFromExcel"
                v-on:clear-file="clearFileExcel"
                :cmdUrl="'orders/import-status-excel'"
              />
              <span v-if="fileName"
                >Tên file: <b>{{ fileName }}</b>
              </span>
            </b-col>
          </b-row>
        </div>
        <div class="flex-column">
          <b-row class="my-2">
            <b-col cols="4">
              <b-form-group
                label-cols-sm="4"
                label-cols-lg="4"
                label="Chọn trạng thái"
                label-class="font-weight-bold"
                class="mb-0 flex-column align-items-center"
              >
                <treeselect
                  :options="optionStatus"
                  :multiple="false"
                  placeholder="Nhập trạng thái:"
                  noResultsText="Không có kết quả"
                  :match-keys="['label', 'custom']"
                  v-model="statusParent"
                  openDirection="bottom"
                  :clearable="false"
                  @select="onSelectStatus"
                >
                  <label
                    slot="option-label"
                    slot-scope="{ node, labelClassName }"
                    :class="labelClassName"
                  >
                    <span :title="node.label"> {{ node.label }}</span>
                  </label>
                </treeselect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="my-2">
            <b-col cols="4">
              <b-form-group
                label-cols-sm="4"
                label-cols-lg="4"
                label="Phân loại khách"
                label-class="font-weight-bold"
                class="mb-0"
                v-if="statusParent === ENUM.ORDER_STATUS.UN_SUCCESS"
              >
                <treeselect
                  :options="optionCustomerClassification"
                  :multiple="false"
                  placeholder="Chọn phân loại:"
                  noResultsText="Không có kết quả"
                  :match-keys="['label', 'custom']"
                  v-model="customerClassificationParent"
                  openDirection="bottom"
                  :clearable="false"
                  @select="onSelectCustomerClassification"
                >
                  <label
                    slot="option-label"
                    slot-scope="{ node, labelClassName }"
                    :class="labelClassName"
                  >
                    <span :title="node.label"> {{ node.label }}</span>
                  </label>
                </treeselect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="my-2" v-if="showCancelReasonInput">
            <b-col cols="4">
              <b-form-group
                label-cols-sm="4"
                label-cols-lg="4"
                label="Lý do huỷ"
                label-class="font-weight-bold"
                class="mb-0"
              >
                <treeselect
                  :key="`parent-cancel-${customerClassificationParent}`"
                  :options="
                    getCancelStatusOptions({
                      toStatus: statusParent,
                      customerClassification: customerClassificationParent,
                    })
                  "
                  :multiple="false"
                  placeholder="Nhập lý do:"
                  noResultsText="Không có kết quả"
                  :match-keys="['label', 'custom']"
                  v-model="statusCancelParent"
                  openDirection="bottom"
                  :clearable="false"
                  @select="onSelectCancelStatus"
                >
                  <label
                    slot="option-label"
                    slot-scope="{ node, labelClassName }"
                    :class="labelClassName"
                  >
                    <span :title="node.label"> {{ node.label }}</span>
                  </label>
                </treeselect>
              </b-form-group>
            </b-col>
          </b-row>

          <b-table
            class="table-common mt-4"
            hover
            bordered
            :items="items"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template #cell(statusValidate)="data">
              <div v-if="!data.item.onLoading" class="d-table-row">
                <div class="d-table-cell align-middle" style="width: 10%">
                  <i
                    v-b-tooltip.hover
                    :title="htmlGetStatusValidate(data.item, 'title')"
                    :class="htmlGetStatusValidate(data.item, 'class')"
                  ></i>
                </div>
                <div
                  class="d-table-cell align-middle pb-1 pl-2"
                  style="width: 90%"
                >
                  {{ data.item.statusValidateName }}
                </div>
              </div>
              <div v-else>
                <b-spinner
                  small
                  label="Small Spinner"
                  variant="primary"
                  class="mr-1"
                ></b-spinner>
                <span class="text-primary">Đang xử lí...</span>
              </div>
            </template>
            <template #cell(storeId)="data">
              <span>
                {{ data.item.storeName }}
              </span>
            </template>
            <template #cell(status)="data">
              <b-form-group class="mb-0 d-flex align-items-center">
                <div class="d-table-row">
                  <div class="d-table-cell align-middle" style="width: 30%">
                    <label class="font-weight-bold pt-1">
                      {{ data.item.statusName }}
                    </label>
                  </div>
                  <div class="d-table-cell align-middle" style="width: 10%">
                    <i
                      class="fa fa-arrow-right text-primary"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <div
                    class="d-table-cell align-middle mb-0"
                    style="width: 65%"
                  >
                    <treeselect
                      :options="optionStatus"
                      :multiple="false"
                      placeholder="Chọn trạng thái"
                      noResultsText="Không có kết quả"
                      :match-keys="['label', 'custom']"
                      v-model="data.item.toStatus"
                      openDirection="bottom"
                      :clearable="false"
                      @select="onChangeStatus(data.item, $event)"
                      class="m-2"
                    >
                      <label
                        slot="option-label"
                        slot-scope="{ node, labelClassName }"
                        :class="labelClassName"
                      >
                        <span :title="node.label"> {{ node.label }}</span>
                      </label>
                    </treeselect>
                    <span
                      class="tree-select-custom"
                      v-if="data.item.toStatus === ENUM.ORDER_STATUS.UN_SUCCESS"
                    >
                      <treeselect
                        :options="optionCustomerClassification"
                        :multiple="false"
                        placeholder="Chọn phân loại khách"
                        noResultsText="Không có kết quả"
                        :match-keys="['label', 'custom']"
                        v-model="data.item.customerClassification"
                        openDirection="bottom"
                        :clearable="false"
                        @select="
                          onChangeCustomerClassification(data.item, $event)
                        "
                        class="m-2"
                      >
                        <label
                          slot="option-label"
                          slot-scope="{ node, labelClassName }"
                          :class="labelClassName"
                        >
                          <span :title="node.label"> {{ node.label }}</span>
                        </label>
                      </treeselect>
                    </span>
                    <span
                      class="mb-0"
                      v-if="htmlIsShown(data.item.toStatus, 'cancel-status')"
                    >
                      <treeselect
                        :key="`item-cancel-${data.item.id}-${data.item.customerClassification}`"
                        :options="getCancelStatusOptions(data.item)"
                        :multiple="false"
                        placeholder="Chọn lý do huỷ"
                        noResultsText="Không có kết quả"
                        :match-keys="['label', 'custom']"
                        v-model="data.item.cancelStatus"
                        openDirection="bottom"
                        :clearable="false"
                        class="m-2"
                      >
                        <label
                          slot="option-label"
                          slot-scope="{ node, labelClassName }"
                          :class="labelClassName"
                        >
                          <span :title="node.label"> {{ node.label }}</span>
                        </label>
                      </treeselect>
                    </span>
                  </div>
                </div>
              </b-form-group>
            </template>
            <template #cell(actions)="row">
              <v-icon
                small
                class="text-danger"
                @click="onRemovedItem(row.item.id)"
                v-b-tooltip
                >mdi-delete</v-icon
              >
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            v-show="rows > perPage"
            aria-controls="my-table"
          ></b-pagination>
          <vcl-table
            v-if="onLoadingList"
            :speed="5"
            :animate="true"
            :columns="10"
            class="mb-4"
          ></vcl-table>
        </div>
      </div>
      <b-overlay
        :show="onLoadingList || isBusy"
        rounded
        opacity="0.6"
        class="d-inline-block mr-3"
      >
        <template #overlay>
          <div class="d-flex align-items-center">
            <b-spinner variant="light" small type="grow"></b-spinner>
          </div>
        </template>
        <b-button
          variant="primary"
          size="sm"
          :disabled="!items.length || items.some((item) => !item.statusValidate)"
          @click="onSaveOrderStatus"
        >
          <strong>Cập nhật</strong>
        </b-button>
      </b-overlay>

      <b-button
        style="width: 80px"
        variant="secondary"
        size="sm"
        :disabled="isBusy"
        @click="hideModalChangeStatus()"
      >
        <strong>Hủy</strong>
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import apiCommonMixin from '@/view/mixins/api-common.mixins.js';
import linkMixin from '@/view/mixins/link.mixins.js';
import { validationMixin } from 'vuelidate';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { mapGetters } from 'vuex';
import { SET_ORDER_STATUS_SELECTED } from '@/core/services/store/modules/order/order-seleted-status.module.js';
import {
  CUSTOMER_CLASSIFICATION,
  ORDER_CANCEL_STATUS,
  ORDER_CANCEL_STATUS_CR,
  ORDER_CANCEL_STATUS_CUSTOMER_COME_TO_STORE,
  ORDER_CANCEL_STATUS_CUSTOMER_NOT_COME,
  ORDER_CANCEL_STATUS_DP,
  ORDER_CANCEL_STATUS_SHOP,
  ORDER_CANCEL_STATUS_SHOP_NOT_COME,
  ORDER_STATUS,
  ORDER_STATUS_CR,
  ORDER_STATUS_DP,
  ORDER_STATUS_SHOP,
  TIME_TRIGGER,
} from '@/utils/constants';
import {
  checkGroupOrderStatus,
  checkJobTitle,
  cloneDeep,
  filterCancelReasonsForCRLeader,
  filterByRoles,
  makeToastFaile,
  makeToastSuccess,
  shouldUseShopNotComeReasons,
  wait,
} from '@/utils/common';
import { VclTable } from 'vue-content-loading';
import { EventBus } from '@/core/services/event-bus';
import ENUM from '@/utils/enum';
import UploadFileMulter from '@/view/modules/upload/UploadFileMulter';
import { URL_IMPORT_ORDER_STATUS } from '../../../utils/constants';
import { showConfirmDialog } from '@/utils/sweet-alert2';

const STATUS_VALIDATE = {
  INVALID: 0,
  VALID: 1,
  REQUIRED: 2,
};
const thStyleCommon = {
  textAlign: 'center',
  fontWeight: 600,
  color: '#181c32',
  width: '5%',
};

export default {
  mixins: [validationMixin, apiCommonMixin, linkMixin],
  props: {
    userInfor: Object,
    param: Object,
    mode: String,
  },
  components: {
    Treeselect,
    VclTable,
    UploadFileMulter,
  },
  data() {
    return {
      fields: [],
      ENUM,
      defaultFields: [
        {
          key: 'id',
          label: 'ID',
          thStyle: {
            ...thStyleCommon,
            width: '5%',
          },
          formatter: (value) => {
            return `#${value}`;
          },
          tdClass: 'align-middle',
        },
        {
          key: 'storeId',
          label: 'Cửa hàng',
          thStyle: {
            ...thStyleCommon,
            width: '20%',
          },
          tdClass: 'text-center align-middle',
        },
        {
          key: 'status',
          label: 'Đổi trạng thái',
          thStyle: {
            ...thStyleCommon,
            width: '50%',
          },
          tdClass: 'align-middle',
        },
        {
          key: 'statusValidate',
          label: 'Kiểm tra',
          thStyle: {
            ...thStyleCommon,
            width: '28%',
          },
          tdClass: 'align-middle',
        },
        {
          key: 'actions',
          label: '',
          tdClass: 'align-middle',
        },
      ],
      items: [],
      itemsTerm: [],
      optionCancelStatus: [],
      optionStatus: [],
      onLoadingList: false,
      isBusy: false,
      statusParent: null,
      statusCancelParent: null,
      changingStatusStores: [],
      optionCustomerClassification: [],
      customerClassificationParent: null,
      isSelectedStore: null,
      currentPage: 1,
      perPage: 10,
      urlExcel: URL_IMPORT_ORDER_STATUS,
      fileName: '',
      file: null,
      show: false,
      isCancelled: false,
    };
  },
  watch: {
    getOrderStatus: {
      handler(value) {
        this.itemsTerm = value;
      },
      deep: true,
    },
    $props: {
      handler() {
        switch (this.mode) {
          case 'changeStatus':
            this.selectedStatus = null;
            this.selectedCancelStatus = null;
            this.customerClassificationParent = null;
            break;
          default:
            break;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.initConstants();
  },
  mounted() {
    EventBus.$on('popup-common-order-excel', this.popupOrderCommon);
  },
  beforeDestroy() {
    EventBus.$off('popup-common-order-excel', this.popupOrderCommon);
  },
  computed: {
    ...mapGetters(['getOrderStatus']),

    rows() {
      return this.items.length;
    },

    showCancelReasonInput() {
      return this.htmlIsShown(this.statusParent, 'cancel-status');
    },
  },
  methods: {
    showConfirmDialog,

    transformToTreeselectOptions(items) {
      return items.reduce((result, element) => {
        if (element.value !== null) {
          result.push({
            id: Number(element.value),
            label: element.text,
            custom: element.text.toLowerCase().replace(/\s+/g, ''),
            customLabel: element.text,
            originalValue: element.value,
          });
        } else {
          result.push({
            id: -1,
            label: element.text,
            custom: element.text.toLowerCase(),
            customLabel: element.text,
            originalValue: null,
          });
        }
        return result;
      }, []);
    },

    initConstants() {
      const userInfor = this.userInfor;
      this.fields = this.defaultFields;

      let cancelStatus = [];
      let status = [];
      const jobTitleId = userInfor.jobTitleId;

      if (checkJobTitle().isCR(jobTitleId)) {
        cancelStatus = ORDER_CANCEL_STATUS_CR;
        status = ORDER_STATUS_CR;
      } else if (checkJobTitle().isShop(jobTitleId)) {
        cancelStatus = ORDER_CANCEL_STATUS_SHOP;
        status = ORDER_STATUS_SHOP;
      } else if (checkJobTitle().isDP(jobTitleId)) {
        cancelStatus = ORDER_CANCEL_STATUS_DP;
        status = ORDER_STATUS_DP;
      } else {
        cancelStatus = ORDER_CANCEL_STATUS;
        status = ORDER_STATUS;
      }

      cancelStatus = filterCancelReasonsForCRLeader(
        cancelStatus,
        jobTitleId,
      );

      this.optionCancelStatus = this.transformToTreeselectOptions(cancelStatus);
      this.optionStatus = this.transformToTreeselectOptions(status);

      this.optionCustomerClassification = this.transformToTreeselectOptions(
        CUSTOMER_CLASSIFICATION,
      );
    },

    htmlIsShown(value, name) {
      let check = false;
      switch (name) {
        case 'cancel-status': {
          const status = [
            ENUM.ORDER_STATUS.UN_SUCCESS,
            ENUM.ORDER_STATUS.SYSTEM_CANCEL,
            ENUM.ORDER_STATUS.CR_CANCEL,
          ];

          if (status.includes(value)) {
            check = true;
          }

          break;
        }
      }
      return check;
    },
    htmlRowClass(item, type) {
      if (!item || type !== 'row') return;

      if (this.userInfor.storeId !== item.storeId) {
        return 'table-danger';
      }
    },
    htmlGetStatusValidate(item, type) {
      let name = '';
      switch (item.statusValidate) {
        case STATUS_VALIDATE.VALID: {
          name =
            type === 'class' ? 'fas fa-check-circle text-success' : 'Hợp lệ';

          break;
        }
        case STATUS_VALIDATE.REQUIRED: {
          name =
            type === 'class'
              ? 'fas fa-check-circle text-warning'
              : 'Chưa chọn lí do';
          break;
        }
        default: {
          name =
            type === 'class'
              ? 'fas fa-times-circle text-danger'
              : 'Không hợp lệ';
          break;
        }
      }
      return name;
    },
    onSelectStatus(node) {
      this.isSelectedStore = false;
      const statusChanged = node.id;

      this.resetParentClassifications({ statusId: statusChanged });

      this.items.forEach((item) => {
        this.updateItemStatus({
          item,
          statusNode: node,
          statusId: statusChanged,
        });
      });
    },
    resetParentClassifications({ statusId }) {
      if (statusId !== ENUM.ORDER_STATUS.UN_SUCCESS) {
        this.customerClassificationParent = null;
      }
      this.statusCancelParent = null;
    },

    updateItemStatus({ item, statusNode, statusId }) {
      const [statusValidate, statusValidateName] = this.validationStoreStatus(
        item.status,
        statusId,
      );

      item.toStatus = statusNode.id;
      item.toStatusName = statusNode.label;
      item.statusValidate = statusValidate;
      item.statusValidateName = statusValidateName;

      this.resetItemClassifications({ item, statusId });
    },

    resetItemClassifications({ item, statusId }) {
      if (statusId !== ENUM.ORDER_STATUS.UN_SUCCESS) {
        this.$set(item, 'customerClassification', null);
        this.$set(item, 'customerClassificationName', null);
      }
      this.$set(item, 'cancelStatus', null);
      this.$set(item, 'cancelStatusName', null);
    },

    onChangeStatus(storeSelected, event) {
      // Check if user change status of all stores with only 1 select
      // but then user wanna changes status of each store
      if (!this.isSelectedStore) {
        const newListStores = [...this.items];
        const isExistStore = newListStores.find(
          (store) => store.id === storeSelected.id,
        );
        const currentStatus = isExistStore.status;
        const newStatus = event.id;
        const [statusValidate, statusValidateName] = this.validationStoreStatus(
          currentStatus,
          newStatus,
        );
        isExistStore.toStatus = event.id;
        isExistStore.toStatusName = event.label;
        isExistStore.statusValidate = statusValidate;
        isExistStore.statusValidateName = statusValidateName;

        if (newStatus !== ENUM.ORDER_STATUS.UN_SUCCESS) {
          this.$set(isExistStore, 'customerClassification', null);
          this.$set(isExistStore, 'customerClassificationName', null);
        }
        this.$set(isExistStore, 'cancelStatus', null);
        this.$set(isExistStore, 'cancelStatusName', null);
      }
      // Check if user changes status of each store
      else {
        this.isSelectedStore = true;
        this.changingStatusStores.push(storeSelected);
        const newListChangingStores = [...this.changingStatusStores];
        const isExistStore = newListChangingStores.find(
          (store) => store.id === storeSelected.id,
        );
        const currentStatus = isExistStore.status;
        const newStatus = event.id;
        const [statusValidate, statusValidateName] = this.validationStoreStatus(
          currentStatus,
          newStatus,
        );
        isExistStore.toStatus = event.id;
        isExistStore.toStatusName = event.label;
        isExistStore.statusValidate = statusValidate;
        isExistStore.statusValidateName = statusValidateName;

        // Reset customer classification and cancel status when status changes
        if (newStatus !== ENUM.ORDER_STATUS.UN_SUCCESS) {
          this.$set(isExistStore, 'customerClassification', null);
          this.$set(isExistStore, 'customerClassificationName', null);
        }
        this.$set(isExistStore, 'cancelStatus', null);
        this.$set(isExistStore, 'cancelStatusName', null);
      }
    },

    onSelectCustomerClassification(node) {
      this.customerClassificationParent = node.id;
      this.statusCancelParent = null;

      // Update all items with new classification and reset cancel status
      this.items.forEach((item) => {
        this.$set(item, 'customerClassification', node.id);
        this.$set(item, 'customerClassificationName', node.label);
        this.$set(item, 'cancelStatus', null);
        this.$set(item, 'cancelStatusName', null);
      });
    },

    onChangeCustomerClassification(storeSelected, event) {
      const storeIndex = this.items.findIndex(
        (store) => store.id === storeSelected.id,
      );

      if (storeIndex !== -1) {
        this.$set(this.items[storeIndex], 'customerClassification', event.id);
        this.$set(
          this.items[storeIndex],
          'customerClassificationName',
          event.label,
        );
        this.$set(this.items[storeIndex], 'cancelStatus', null);
        this.$set(this.items[storeIndex], 'cancelStatusName', null);
      }
    },

    getCancelStatusOptions(item) {
      return item.toStatus === ENUM.ORDER_STATUS.UN_SUCCESS &&
        item.customerClassification
        ? this.getCustomerCancelOptions(item.customerClassification)
        : this.optionCancelStatus;
    },

    getCustomerCancelOptions(customerClassification) {
      let cancelOptions = [];
      const jobTitleId = this.userInfor.jobTitleId;
      // SHOP + "Khách không đến": dùng bộ lý do huỷ chuyên biệt
      if (shouldUseShopNotComeReasons(jobTitleId, customerClassification)) {
        return this.transformToTreeselectOptions(
          filterCancelReasonsForCRLeader(
            ORDER_CANCEL_STATUS_SHOP_NOT_COME,
            jobTitleId,
          ),
        );
      }
      const roleName = [];

      if (customerClassification) {
        if (
          customerClassification ===
          Number(ENUM.CUSTOMER_CLASSIFICATION_TYPE.NOT_COME)
        ) {
          // Khách không đến
          cancelOptions = ORDER_CANCEL_STATUS_CUSTOMER_NOT_COME;
        } else if (
          customerClassification ===
          Number(ENUM.CUSTOMER_CLASSIFICATION_TYPE.COME_TO_STORE)
        ) {
          // Khách đến CH
          cancelOptions = ORDER_CANCEL_STATUS_CUSTOMER_COME_TO_STORE;
        }
      }

      if (checkJobTitle().isCR(jobTitleId)) {
        roleName.push('CR');
      } else if (checkJobTitle().isShop(jobTitleId)) {
        roleName.push('SHOP');
      } else if (checkJobTitle().isDP(jobTitleId)) {
        roleName.push('DP');
      }

      if (roleName.length > 0) {
        cancelOptions = filterByRoles(cancelOptions, roleName);
      }

      cancelOptions = filterCancelReasonsForCRLeader(
        cancelOptions,
        jobTitleId,
      );

      return this.transformToTreeselectOptions(cancelOptions);
    },

    getUniqueList(arr, key) {
      // NOTE: item in under function is store
      return [...new Map(arr.map((item) => [item[key], item])).values()];
    },
    hideModalChangeStatus() {
      if (this.items.length) {
        const description = `Bạn có chắc chắn muốn hủy cập nhật trạng thái đơn hàng?`;
        this.showConfirmDialog(`Hủy cập nhật!`, description)
          .then(async () => {
            if (!this.isBusy) {
              this.changingStatusStores = [];
              this.items = [];
              this.isSelectedStore = null;
            } else {
              this.isCancelled = true;
            }
            this.$bvModal.hide('md-change-status-excel');
          })
          .catch(() => {
            // Xử lý khi người dùng nhấn "Hủy"
            this.isCancelled = false;
          });
      } else {
        this.$bvModal.hide('md-change-status-excel');
        this.changingStatusStores = [];
        this.items = [];
        this.isSelectedStore = null;
      }
    },
    validationStoreStatus(statusChild, statusChanged) {
      let statusValidate = STATUS_VALIDATE.VALID;
      let statusValidateName = 'Hợp lệ';

      if (statusChanged === -1) {
        statusValidate = STATUS_VALIDATE.INVALID;
        statusValidateName = 'Chưa chọn';
        return [statusValidate, statusValidateName];
      }

      try {
        const changedGroup = checkGroupOrderStatus().getByGroup(statusChanged);
        const sourceGroup = checkGroupOrderStatus().getByGroup(statusChild);
        const checkStatus = checkGroupOrderStatus().valid(
          sourceGroup,
          changedGroup,
        );

        if (!checkStatus) {
          statusValidate = STATUS_VALIDATE.INVALID;
          statusValidateName = 'Không hợp lệ';
        }
      } catch (error) {
        makeToastFaile(error.message);
        statusValidate = STATUS_VALIDATE.INVALID;
        statusValidateName = error.message;
      }

      return [statusValidate, statusValidateName];
    },
    onSelectCancelStatus(node) {
      this.items.map((item) => {
        item.cancelStatus = node.id;
        item.cancelStatusName = node.label;
      });
    },
    onRemovedItem(itemRemoveId) {
      if (this.isBusy) {
        return makeToastFaile('Không thể xóa khi đang cập nhật!');
      }
      const findIndexBy = (items, itemRemoveId) => {
        return items.findIndex((item) => item.id === itemRemoveId);
      };

      const index = findIndexBy(this.items, itemRemoveId);
      if (index > -1) {
        this.items.splice(index, 1);
        this.$store.dispatch(SET_ORDER_STATUS_SELECTED, this.items);
        EventBus.$emit('re-seletect-order', this.items);
      }
    },
    onSaveOrderStatus: async function () {
      const isSelectedStore = this.isSelectedStore;
      const uniqueListStores = this.getUniqueList(
        this.changingStatusStores,
        'id',
      );
      const items = isSelectedStore
        ? cloneDeep(uniqueListStores)
        : cloneDeep(this.items);
      // NOTE: invalids means a list of store that's fail the validate when changing from current status to new status
      const invalids = items.filter((item) => !item.statusValidate);

      if (invalids.length) {
        return makeToastFaile(
          `Đơn hàng không hợp lệ ${invalids.map((item) => item.id).join()}`,
        );
      }
      if (items.length > 100) {
        return makeToastFaile(
          `Vui lòng không cập nhật quá 100 đơn hàng cùng lúc!`,
        );
      }
      if (!items.length) {
        return makeToastFaile(
          'Vui lòng tải lên file đơn hàng hợp lệ trước khi cập nhật!',
        );
      }
      if (!this.isBusy) {
        this.isBusy = true;
        const dataMessages = {
          success: [],
          failed: [],
        };
        let setTimeoutLasted = false;
        for (const item of items) {
          if (this.isCancelled) {
            break;
          }
          const index = this.items.findIndex((e) => e.id === item.id);

          if (index > -1) {
            this.items[index].onLoading = true;
            // Tính toán trang chứa item đang được cập nhật
            const itemPage = Math.ceil((index + 1) / this.perPage);
            if (itemPage !== this.currentPage) {
              this.currentPage = itemPage;
            }
          }

          // Validate customer classification
          if (
            item.toStatus === ENUM.ORDER_STATUS.UN_SUCCESS &&
            !item.customerClassification
          ) {
            dataMessages.failed.push(item);
            if (index > -1) {
              this.items[index].onLoading = false;
              this.items[index].statusValidate = STATUS_VALIDATE.INVALID;
              this.items[
                index
              ].statusValidateName = `Vui lòng chọn phân loại khách hàng`;
            }
            continue;
          }

          const param = {
            id: item.id,
            status: item.toStatus,
            storeId: item.storeId,
            cancelStatus: item.cancelStatus,
            customerClassification: item.customerClassification,
          };

          const [status, message] = await ApiService.put(
            `/orders/status/`,
            param,
          )
            .then((response) => {
              const { status, message } = response.data;
              return [status, message];
            })
            .catch((err) => {
              this.$nprogress.done();
              if (!err.response) {
                // network error
                return [0, 'Lỗi mạng'];
              } else {
                const message = err.response.data.message;
                return [0, message];
              }
            });
          await wait(2000);
          setTimeoutLasted = true;
          this.items[index].onLoading = false;
          if (status) {
            dataMessages.success.push(item);
            this.items[index].statusValidate = STATUS_VALIDATE.VALID;
            this.items[index].statusValidateName = 'Cập nhật thành công';
          } else {
            this.items[index].statusValidate = STATUS_VALIDATE.INVALID;
            this.items[index].statusValidateName = message;
          }
        }
        this.isBusy = false;
        if (dataMessages.success.length === items.length) {
          if (setTimeoutLasted) this.items = [];
          await this.$store.dispatch(SET_ORDER_STATUS_SELECTED, this.items);
          makeToastSuccess('Cập nhật trạng thái đơn hàng thành công');
          this.fileName = '';
          this.changingStatusStores = [];
          this.isSelectedStore = null;
          this.$emit('refresh', true);
        } else {
          if (this.isCancelled) {
            this.changingStatusStores = [];
            this.fileName = '';
            this.isSelectedStore = null;
            this.isCancelled = false;
            return;
          }
          this.changingStatusStores = [];
          this.this.isSelectedStore = null;
          makeToastFaile('Đơn hàng cập nhật thất bại');
        }
      }
    },
    getOrderByIds(orders) {
      this.onLoadingList = true;
      this.items = [];
      const orderIds = orders.map((order) => order.id);

      ApiService.post(`/orders/status/ids`, {
        orderIds,
      })
        .then((response) => {
          const { data } = response.data;
          const { status, message } = response.data;

          if (status) {
            setTimeout(() => {
              this.items = data;
              this.onLoadingList = false;
            }, TIME_TRIGGER);
          } else {
            makeToastFaile(message);
            this.onLoadingList = false;
          }
        })
        .catch((err) => {
          if (!err.response) {
            // network error
            makeToastFaile('Lỗi!');
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
          this.onLoadingList = false;
          this.$nprogress.done();
        });
    },
    popupOrderCommon() {
      // if (!this.itemsTerm.length) {
      //   makeToastFaile('Vui lòng chọn lại đơn hàng');
      //   this.$store.dispatch(SET_ORDER_STATUS_SELECTED, this.items);
      //   EventBus.$emit('re-seletect-order', this.items);
      //   return;
      // }

      this.$bvModal.show('md-change-status-excel');

      this.statusParent = null;
      this.statusCancelParent = null;
      // this.getOrderByIds(this.itemsTerm);
    },
    getDataFromExcel(data, fileName) {
      if (this.isBusy) {
        return makeToastFaile('Không thể  tải file khi đang cập nhật!');
      }
      this.fileName = fileName;
      const orderIds = data.rows.reduce((acc, item) => {
        if (item.isValid) {
          acc.push(item.orderCode); // Thêm orderCode hợp lệ vào mảng
        }
        return acc;
      }, []);
      const orderIdsError = data.rows.filter((item) => !item.isValid);

      ApiService.post(`/orders/status/ids`, {
        orderIds,
      })
        .then((response) => {
          const { data } = response.data;
          const { status, message } = response.data;

          if (status) {
            setTimeout(() => {
              this.items = data;
              orderIdsError.forEach((order) => {
                this.items.push({
                  id: order.orderCode,
                  storeId: null,
                  storeName: null,
                  status: null,
                  statusName: null,
                  cancelStatus: null,
                  cancelStatusName: null,
                  customerClassification: null,
                  customerClassificationName: null,
                  toStatus: null,
                  toStatusName: null,
                  statusValidate: 0,
                  statusValidateName: order.errors.join(', '),
                  onLoading: false,
                });
              });
              this.onLoadingList = false;
              this.isCancelled = false;
            }, TIME_TRIGGER);
          } else {
            makeToastFaile(message);
            this.onLoadingList = false;
            this.isCancelled = false;
          }
        })
        .catch((err) => {
          if (!err.response) {
            // network error
            makeToastFaile('Lỗi!');
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
          this.onLoadingList = false;
          this.$nprogress.done();
        });

      // const inValidItems = this.importItems.filter(
      //   (importItem) => !importItem.isValid,
      // );
      // this.isInValid = !!inValidItems.length;
    },
    clearFileExcel() {
      if (this.isBusy) {
        return makeToastFaile('Không thể xóa file khi đang cập nhật!');
      }
      this.items = [];
      this.fileName = '';
      this.isCancelled = false;
    },
  },
};
</script>

<style scoped>
.table-common /deep/ .vue-treeselect__input-container {
  padding-top: 0px;
}

.table-common /deep/ .vue-treeselect__control {
  border-radius: none;
  border: none;
  height: 2.5rem;
}

.table-common /deep/ .vue-treeselect__input {
  font-size: 22px;
}
</style>
